<template>
  <div>
    <mdb-btn color="default" outline="success" size="sm" @click.native="contact=true">contact<mdb-icon icon="phone-alt" class="ml-1"/></mdb-btn>
    <mdb-modal :show="contact" @close="contact = false">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Talk to us</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3 grey-text">
        <mdb-input label="Your name" icon="user" class="mb-5" v-model="newName"/>
        <mdb-input label="Your email" icon="envelope" type="email" class="mb-5" v-model="newEmail"/>
        <mdb-input label="Your Phone Number" icon="phone-alt" class="mb-5" v-model="newPhoneNumber"/>
        <mdb-textarea icon="pencil-alt" label="Your message" v-model="newMessage"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click.native="contact = false" color="unique" @click ="addContact()">Send <mdb-icon icon="paper-plane" class="ml-1"/></mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import { contactsCollection } from '@/firebase'
import mdbBtn from 'mdbvue/lib/components/mdbBtn'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbModal from 'mdbvue/lib/components/mdbModal'
import mdbModalHeader from 'mdbvue/lib/components/mdbModalHeader'
import mdbModalBody from 'mdbvue/lib/components/mdbModalBody'
import mdbModalFooter from 'mdbvue/lib/components/mdbModalFooter'
import mdbInput from 'mdbvue/lib/components/mdbInput'
import mdbModalTitle from 'mdbvue/lib/components/mdbModalTitle'
import mdbTextarea from 'mdbvue/lib/components/mdbTextarea'

export default {
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbModalTitle,
    mdbIcon,
    mdbTextarea
  },
  data () {
    return {
      contact: false,
      newName: '',
      newEmail: '',
      newPhoneNumber: '',
      newMessage: '',
      contacts: []
    }
  },
  firestore () {
  },
  methods: {
    addContact () {
      contactsCollection.add({
        name: this.newName,
        email: this.newEmail,
        phoneNumber: this.newPhoneNumber,
        message: this.newMessage,
        id: this.contacts.length,
        createdAt: new Date()
      })
      this.newName = ''
      this.newEmail = ''
      this.newPhoneNumber = ''
      this.newMessage = ''
    }
  }
}
</script>
